/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export class InfocardNavigationConstants {
    public static INFO_CARD_EAST = 'info-card-east';

    public static INFO_CARD_WEST = 'info-card-west';

    public static INFO_CARD_GLOBAL_MOUSE = 'info-card-global-mouse-trap';

    public static INFO_CARD_SHIELD = 'info-card-shield';
}
